import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'

type EditTagsManagementFormState = {
	isFormValid: boolean
	formValues: Record<string, any>
}

type EditTagsManagementFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		setFormValidity: (isValid: boolean) => void
		setOriginalRequestFormValues: (
			originalProjectRequestValues: EditTagsManagementFormState
		) => void
	}
}

const initialFormValues = {
	platformName: '',
	tagProject: '',
	//platformRepo: '',
	systemAlias: '',
	dataClassification: '',
	fundingSourceType: '',
	costCenter: '',
	WBSCode: ''
}

const editTagsManagementFormStore = create<
	EditTagsManagementFormState & EditTagsManagementFormActions
>((set, _get) => ({
	isFormValid: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () => set(() => ({ formValues: initialFormValues })),

		setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),
		setOriginalRequestFormValues: (originalProjectRequestValues) =>
			set(() => ({
				formValues: originalProjectRequestValues.formValues
			})),

		setFormValues: (fieldName, value) =>
			set((state) =>
				produce(state, (draft) => {
					draft.formValues[fieldName] = value
				})
			)
	}
}))

export const useEditTagsManagementFormStore = () =>
	editTagsManagementFormStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool('EditTagsManagementFormStore', editTagsManagementFormStore)
}
